import { FocusTheme, FOCUS_GRADIENT_1 } from '@/components/Focus/configs/theme';
import { styled } from '@mui/material/styles';

const shouldForwardProp = (prop: string) => prop !== 'gradient' && prop !== 'radius' && prop !== 'thickness';

type GradientBorderBoxProps = {
  gradient?: string;
  radius?: number;
  thickness?: number;
};

const GradientBorderBox = styled('div', {
  shouldForwardProp
})<GradientBorderBoxProps>(({ theme, gradient = FOCUS_GRADIENT_1, radius, thickness = 1.5 }) => {
  const focusTheme = theme as FocusTheme;
  const resolvedRadius = radius ?? Number(focusTheme.shape.borderRadius ?? 8);

  return {
    background: `
      linear-gradient(${focusTheme.palette.neutral[90]}, ${focusTheme.palette.neutral[90]}) padding-box,
      ${gradient} border-box
    `,
    border: `${thickness}px solid transparent`,
    borderRadius: resolvedRadius,
    boxSizing: 'border-box',
    display: 'block',
    minWidth: 0,
    width: '100%'
  };
});

export default GradientBorderBox;
